{
  "dropzoneLabel": "Zona di rilascio",
  "selectPlaceholder": "Seleziona un elemento",
  "tableResizer": "Ridimensionamento",
  "colorSwatchPicker": "Color swatches"
}
